import axios from 'axios';

const API_URL = process.env.VUE_APP_API_URL;

class MOTD {
  async getMOTD() {
    try {
      const { data } = await axios.get(`${API_URL}/motd`)
      return { status: "success", data: data.data }
    } catch(error) {
      if (error.response?.status == 401) {
        return { status: "unauthorized", message: "Not authorized" }
      } else {
        return { status: "error", message: "Failed to fetch MOTD" }
      }
    }
  }
}

export default new MOTD();
